import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'
import priceWithSpaces from './priceWithSpaces'

export default function getConstants(p = {}) {

    const name = 'order'

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Buy',
            ['restore' + N + 'SubmitLabel']: 'Restore',
            ['save' + N + 'SubmitLabel']: 'Save',
            ['cancel' + N + 'Text']: 'Cancel',
            ['continuousShopping' + N + 'Text']: 'Continue shopping',
            ['checkout' + N + 'Text']: 'Finalize order',
            ['delete' + N + 'Text']: 'Delete',
            ['delete' + Ns + 'Text']: 'Delete orders',
            ['ban' + N + 'Text']: 'Ban',
            ['approve' + N + 'Text']: 'Approve',
            ['protection' + N + 'Text']: 'Mark as protected',
            ['removeProtection' + N + 'Text']: 'Remove protection',
            ['select' + N + 'Text']: 'Select',
            ['add' + N + 'Text']: 'Add',

            ['date' + N + 'Format']: ({ dateText = '' }) => {
                if (!dateText) {
                    return dateText
                }
                try {
                    return new Date(dateText).toLocaleString('en-US')
                } catch (e) {
                }
                return dateText
            },

            [ns + 'SortRelevance']: 'Relevance',
            [n + 'TotalText']: ({
                                    total,
                                    currency = 'eur'
                                }) => ((total) ? '' + priceWithSpaces(Math.round(total)) : '0') + ' ' + (currency === 'chf' ? 'CHF' : currency === 'usd' ? '$' : '€'),
            [n + 'ProductTitleLabel']: 'Product',
            [n + 'QuantityLabel']: 'Quantity',
            [n + 'CartSummaryLabel']: 'Total price of products',
            [n + 'AmountLabel']: 'Amount',
            [n + 'SummaryLabel']: 'Total',

            [n + 'InvoiceData']: 'Invoice data',
            [n + 'InvoiceAddress']: 'Invoice address',
            [n + 'Payments']: 'Payments',
            [n + 'Licenses']: 'Licenses',
            [n + 'ContentOrderData']: 'Order data',

            [n + 'CartLabel']: 'Cart',
            [n + 'CartUpdateCartLabel']: 'Update cart',
            [n + 'SummarySubtotal']: 'Subtotal',
            [n + 'SummaryTaxExclusive']: 'Tax exclusive',
            [n + 'SummaryTaxInclusive']: 'Tax inclusive',

            ['redirectToPaymentSubmit']: 'OK',

            [n + 'PaymentInfoTitle']: 'Card payment with Stripe',
            [n + 'PaymentInfoDesc']: 'By clicking on the order button, the page will redirect you to the payment page.',
            [n + 'TotalPriceWithCurrency']: (total, currency = 'eur') => {
                return priceWithSpaces(total) + ' ' + (currency === 'chf' ? 'CHF' : currency === 'usd' ? '$' : '€')
            },

            [n + 'EditInvoiceData']: 'Edit invoice data',

            [n + 'OpenPaymentsSection']: 'Show payments',
            [n + 'ClosePaymentsSection']: 'Close',

            [n + 'OpenLicensesSection']: 'Show licenses',
            [n + 'CloseLicensesSection']: 'Close',

            [n + 'SearchLabel']: 'Search by order ID',
            [n + 'SearchLabelForAdmin']: 'Search by order ID or user',

            [n + 'SummaryOrderBackToTheOrder']: 'Back to the order',

            [n + 'SuccessDialogLicenses']: 'Licenses',
            [n + 'SuccessDialogViewLicenses']: 'View licenses',

            [n + 'SuccessDialogOrder']: 'Order details',
            [n + 'SuccessDialogViewOrder']: 'View order'

        },
        menus: {
            ...menus,
            ['user' + Ns + 'MainMenu']: 'Orders',
            ['my' + Ns + 'MainMenu']: 'My orders',
            ['user' + Ns + 'Menu']: 'Orders',
            ['user' + Ns + 'UnpaidMenu']: 'Unpaid',
            ['user' + Ns + 'ProcessingMenu']: 'Processing',
            ['user' + Ns + 'SuccessMenu']: 'Completed',
            ['my' + Ns + 'Menu']: 'My orders',
            ['new' + N + 'Menu']: 'New order',
            [ns + 'Menu']: 'Orders',
            ['deleted' + Ns + 'Menu']: 'Deleted orders',
            ['banned' + Ns + 'Menu']: 'Permanently deleted orders',
            ['protection' + Ns + 'Menu']: 'Protected orders',
            ['missingData' + Ns + 'Menu']: 'Missing data',
            ['lowAuthorStatus' + Ns + 'Menu']: 'Author with low status',

            ['edit' + N + 'Menu']: 'Edit',
            ['delete' + N + 'Menu']: 'Delete',
            ['ban' + N + 'Menu']: 'Ban',
            ['approve' + N + 'Menu']: 'Approve',
            ['protection' + N + 'Menu']: 'Mark as protected',
            ['removeProtection' + N + 'Menu']: 'Remove protection',

            ['userFeaturedNew' + N + 'Menu']: 'Purchase new licence'
        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'The order has been saved',
            ['save' + N + 'SuccessMessage']: 'The order has been saved',
            ['delete' + N + 'Success']: 'The order has been deleted',
            ['delete' + Ns + 'Success']: 'The orders have been deleted',
            ['delete' + N + 'Question']: 'Are you sure you want to delete the order?',
            ['delete' + Ns + 'Question']: 'Are you sure you want to delete the orders?',
            ['ban' + N + 'Success']: 'The order has been permanently deleted',
            ['ban' + N + 'Question']: 'Are you sure you want to permanently delete the order?',
            ['approve' + N + 'Success']: 'The order has been approved',
            ['approve' + N + 'Question']: 'Are you sure you want to approve the order?',
            ['protection' + N + 'Success']: 'The order has been marked as protected',
            ['protection' + N + 'Question']: 'Are you sure you want to mark the order as protected?',
            ['removeProtection' + N + 'Success']: 'The protection has been removed',
            ['removeProtection' + N + 'Question']: 'Are you sure you want to remove the protection?',
            ['thereAreNo' + Ns]: 'There are no orders',

            [n + 'EmptyCart']: 'The cart is empty',
            [n + 'AddToCart']: 'Change licenses',
            [n + 'ChooseProductsCart']: 'Choose licenses',

            ['redirectToPaymentDialogMessage']: 'Redirecting you to payment page, please wait...',
            [n + 'NewPaymentInfoInOrderContent']: ({ lastPayment }) => {
                if (lastPayment?.paymentStatus === 20) {
                    return `The transaction has started but not yet completed. Would you like to restart the payment?`
                } else if (lastPayment?.paymentStatus === 10) {
                    return `The transaction has been rejected. Would you like to restart the payment?`
                }
            },
            ['validation' + N + 'InvoiceCountry']: (example) => 'Supported tax id formats: ' + example,

            [n + 'SuccessDialogLicensesContent']: 'If you have purchased multiple licenses, you can allocate them to different users on your account any time in the future.',
            [n + 'SuccessDialogOrderContent']: 'If you want to view the data related to your order or download the invoice, you can find it on the order page.'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Order',
            [ns + 'Title']: 'Orders',
            ['new' + N + 'Title']: 'New order',
            ['edit' + N + 'Title']: 'Edit order',
            ['user' + Ns + 'Title']: 'Orders',
            ['user' + Ns + 'UnpaidTitle']: 'Unpaid orders',
            ['user' + Ns + 'ProcessingTitle']: 'Processing orders',
            ['user' + Ns + 'SuccessTitle']: 'Completed orders',
            ['userDeleted' + Ns + 'Title']: 'Deleted orders',
            ['my' + Ns + 'Title']: 'My orders',
            ['myDeleted' + Ns + 'Title']: 'My deleted orders',

            ['dialogDelete' + N + 'Title']: 'Delete order',
            ['dialogBan' + N + 'Title']: 'Permanently delete order',
            ['dialogApprove' + N + 'Title']: 'Approve order',
            ['dialogProtection' + N + 'Title']: 'Mark order as protected',
            ['dialogRemoveProtection' + N + 'Title']: 'Remove protection from order',

            ['dialogDelete' + Ns + 'Title']: 'Delete orders',

            ['statusBanned' + N + 'Title']: 'Permanently deleted',
            ['statusDeleted' + N + 'Title']: 'Deleted',
            ['statusAuthorDeleted' + N + 'Title']: 'Author deleted',
            ['statusMissingData' + N + 'Title']: 'Missing data',
            ['statusApproved' + N + 'Title']: 'Approved',
            ['statusFeatured' + N + 'Title']: 'Protected',
            ['statusCreated' + N + 'Title']: 'Created',

            ['banned' + Ns + 'Title']: 'Permanently deleted orders',
            ['deleted' + Ns + 'Title']: 'Deleted orders',
            ['missingData' + Ns + 'Title']: 'Missing data',
            ['protected' + Ns + 'Title']: 'Protected orders',
            ['lowAuthorStatus' + Ns + 'Title']: 'Author with low status',

            ['select' + Ns]: 'Select orders',
            ['select' + N]: 'Select order',

            [n + 'InvoiceData']: 'Invoice data',

            ['redirectToPaymentDialogTitle']: 'Redirect',

            [n + 'SuccessDialogTitle']: 'Congrats, your payment was successful!'
        }
    }
}
